import { Button } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import React from 'react';
import { LetterBookBadgeDict, LetterBookBadgeIdToLetterDict } from 'util/assignment-badge-util';

type LetterButtonProps = {
  letterId: number;
  letterSelectedCallback: (letter: string) => void;
  selected: boolean;
};
const LetterButton: React.FC<LetterButtonProps> = ({
  letterId,
  letterSelectedCallback,
  selected,
}) => {
  const classes = useStyles();

  return (
    <Button
      className={classes.container}
      onClick={() => letterSelectedCallback(LetterBookBadgeIdToLetterDict[letterId])}
    >
      <img
        className={selected ? classes.selectedCircle : classes.circle}
        src={LetterBookBadgeDict[letterId]}
      />
    </Button>
  );
};

const useStyles = makeStyles(() => ({
  circle: {
    minWidth: '9rem', //this is used to make sure the carousel buttones are't disabled while the images load
    margin: 'auto 0 auto 0',
    height: '100%',
    width: '100%',
    borderRadius: '50%',
    objectFit: 'contain',
  },
  selectedCircle: {
    minWidth: '9rem', //this is used to make sure the carousel buttones are't disabled while the images load
    margin: 'auto 0 auto 0',
    height: '100%',
    width: '100%',
    borderRadius: '50%',
    objectFit: 'contain',
    cursor: 'auto',
    transform: 'scale(1.30, 1.30)',
  },
  container: {
    display: 'inline-block',
    position: 'relative',
    borderRadius: '50%',
    height: '10rem', //i cant get the overflow to work right, so i'm setting a height so it has room to expand on hover
    width: '10rem',
    '&:hover, &:focus': {
      '& span > img': {
        transform: 'scale(1.30, 1.30)',
      },
    },
  },
}));

export default LetterButton;
